"use client";
import axios from "axios";
import { SERVER_AUTH, SERVER_MAHAMART } from "../utils/baseUrl";

const ENDPOINT_LOGIN = `${SERVER_AUTH}/api/auth/login`;

const httpClient = axios.create({
    baseURL: `${SERVER_MAHAMART}`
});

httpClient.interceptors.request.use(
    (config) => {
        // Get whatever auth token/credential your API requires
        const authCredential = localStorage.getItem("access_token");

        if (authCredential && config.url !== ENDPOINT_LOGIN) {
            config.headers.Authorization = `Bearer ${authCredential}`;
        }
        return config;
    },
    (error) => {
        console.log("HttpClient Request Error:", error);
        return Promise.reject(error);
    }
);

httpClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response?.status === 401 || error.response?.status === 403) {
            const token = localStorage.getItem("access_token");
            localStorage.removeItem("access_token");
            localStorage.removeItem("user_info");
            localStorage.removeItem("role");
            if (token) {
                window.location.href = "/login";
            }
        }
        return Promise.reject(error);
    }
);

export default httpClient;
